module.exports = __webpack_public_path__ + "media/app/img/reddit_3-6a6b06c4a56380435c9faee27af30ee5.png";